export default "__VITE_ASSET__RLNuwuor__"